import styled from 'styled-components'

export const InputsWrap = styled('div')`
  display: grid;
  grid-template-columns: 258px 258px;
  margin: 10px 0;
`
